import React, { useEffect, useRef, FC } from "react";
import { compose, withProps, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from "react-google-maps";
import "./MapPanel.scss";

const Map = compose<
  any,
  { location: any; locations: any[]; onClick: () => void }
>(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(
    () => ({
      isOpen: false,
      activeMarker: null,
      directions: null,
      activeInfo: null,
    }),
    {
      onToggleOpen:
        ({ isOpen }) =>
        (marker) => ({
          isOpen: !isOpen,
          activeMarker: marker,
        }),
      showDirection:
        ({ directions }) =>
        (result) => ({
          directions: result,
        }),
      setActiveInfo: () => (active) => ({
        activeInfo: active,
      }),
    }
  ),
  withScriptjs,
  withGoogleMap
)(({ location, locations, onClick, setActiveInfo, activeInfo }) => {
  const mapRef = useRef(null);

  const fitBounds = () => {
    const bounds = new google.maps.LatLngBounds();
    locations.forEach((marker: any) => {
      bounds.extend({ lat: marker.lat, lng: marker.lng });
    });
    if (bounds.isEmpty()) return;
    mapRef.current.fitBounds(bounds);
  };

  useEffect(() => {
    fitBounds();
  }, [locations]);

  return (
    <GoogleMap
      defaultZoom={14}
      center={location}
      onClick={onClick}
      ref={mapRef}
      defaultOptions={{ fullscreenControl: false }}
    >
      {locations?.map((marker: any, idx: number) => (
        <Marker
          key={idx}
          icon={{
            url: `/images/Place-icon.png`,
          }}
          position={{ lat: marker.lat, lng: marker.lng }}
          onClick={() => {
            setActiveInfo(idx);
          }}
        >
          {activeInfo === idx && (
            <InfoWindow
              onCloseClick={() => {
                setActiveInfo(null);
              }}
            >
              <div>
                <div>{marker.title || ""}</div>
              </div>
            </InfoWindow>
          )}
        </Marker>
      ))}
    </GoogleMap>
  );
});

const MapPreview: FC<{ location: any; locations: any[] }> = ({
  location,
  locations,
}) => {
  return (
    <React.Fragment>
      <Map onClick={() => {}} location={location} locations={locations} />
    </React.Fragment>
  );
};

export default MapPreview;
